import { render, staticRenderFns } from "./HeroEditor.vue?vue&type=template&id=1cf3b02c&scoped=true"
import script from "./HeroEditor.vue?vue&type=script&lang=js"
export * from "./HeroEditor.vue?vue&type=script&lang=js"
import style0 from "./HeroEditor.vue?vue&type=style&index=0&id=1cf3b02c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3b02c",
  null
  
)

export default component.exports